import React from 'react';
import { Box, Typography, Card, Grid, Chip } from '@mui/material';
import {
  Lightbulb as LightbulbIcon,
  Whatshot as WhatshotIcon,
  SearchOff as SearchOffIcon,
} from '@mui/icons-material';
import { alpha } from '@mui/material/styles';

export const TabHallazgos = ({ resumen }: { resumen: any }) => {
  const data = resumen?.recurringFindings || [];

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12 }}>
        <Card
          sx={{
            p: 4,
            borderRadius: 3,
            boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
            border: '1px solid #f0f0f0',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
            <LightbulbIcon color="primary" />
            <Typography variant="h6" sx={{ fontWeight: 800, color: '#2e263d' }}>
              Hallazgos Automáticos
            </Typography>
          </Box>
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 4, maxWidth: 800 }}>
            Identifica los puntos de fricción y áreas de mejora más recurrentes en las evaluaciones
            de tus huéspedes. Atiende rápidamente estas tendencias para elevar la calidad de tu
            servicio.
          </Typography>

          <Grid container spacing={3}>
            {data.map((item: any, idx: number) => (
              <Grid size={{ xs: 12, md: 6 }} key={idx}>
                <Box
                  sx={{
                    p: 2.5,
                    borderRadius: 3,
                    border: idx === 0 ? '2px solid' : '1px solid',
                    borderColor: idx === 0 ? 'primary.main' : '#f0f0f0',
                    bgcolor:
                      idx === 0 ? (theme) => alpha(theme.palette.primary.main, 0.03) : '#ffffff',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 2.5,
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                      borderColor: 'primary.main',
                      boxShadow: (theme) => `0 4px 16px ${alpha(theme.palette.primary.main, 0.1)}`,
                      transform: 'translateY(-2px)',
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minWidth: 44,
                      height: 44,
                      borderRadius: '50%',
                      bgcolor:
                        idx === 0
                          ? 'primary.main'
                          : (theme) => alpha(theme.palette.primary.main, 0.1),
                      color: idx === 0 ? '#fff' : 'primary.main',
                      boxShadow:
                        idx === 0
                          ? (theme) => `0 4px 12px ${alpha(theme.palette.primary.main, 0.3)}`
                          : 'none',
                    }}
                  >
                    {idx === 0 ? (
                      <WhatshotIcon fontSize="small" />
                    ) : (
                      <LightbulbIcon fontSize="small" />
                    )}
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    {idx === 0 && (
                      <Typography
                        variant="overline"
                        sx={{
                          fontWeight: 800,
                          color: 'primary.main',
                          display: 'block',
                          lineHeight: 1,
                          mb: 1,
                          letterSpacing: 1,
                        }}
                      >
                        TENDENCIA PRINCIPAL
                      </Typography>
                    )}
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 700, color: '#2e263d', mb: 2, lineHeight: 1.4 }}
                    >
                      "{item.topic}"
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <Chip
                        size="small"
                        label={`${item.mention_count} menciones`}
                        sx={{
                          fontWeight: 700,
                          bgcolor:
                            idx === 0
                              ? 'primary.main'
                              : (theme) => alpha(theme.palette.primary.main, 0.1),
                          color: idx === 0 ? '#fff' : 'primary.main',
                          '& .MuiChip-label': { px: 1.5 },
                        }}
                      />
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: 700,
                          color: 'text.secondary',
                          textTransform: 'uppercase',
                          letterSpacing: 0.5,
                        }}
                      >
                        {item.area}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ))}
            {data.length === 0 && (
              <Grid size={{ xs: 12 }}>
                <Box
                  sx={{
                    py: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                  }}
                >
                  <SearchOffIcon sx={{ fontSize: 56, color: 'text.disabled' }} />
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ textAlign: 'center', maxWidth: 500 }}
                  >
                    Aún no hay suficientes datos para generar hallazgos. A medida que tus huéspedes
                    dejen más comentarios, aquí verás los temas más importantes.
                  </Typography>
                </Box>
              </Grid>
            )}
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
};
